import { GraphQLClient } from 'graphql-request'

const BASE_URL = process.env.API_BASE_URL


const endpoint = BASE_URL + '/api'

const Client = new GraphQLClient(endpoint, {
  mode: 'cors'
})

async function doRequest(query, variables = {}) {
  try {
    const response = await Client.request(query, variables)
    if (response.errors) {
      return Promise.reject(response)
    }

    return Promise.resolve(response)
  } catch (error) {
    return Promise.reject(error)
  }
}

const standardFields = `
  id,
  status,
  slug,
  submission,
  task {
    id,
    type,
    description,
    config,
    scene_number,
    level
  },
  student {
    id,
    name,
    email
  },
  chapter {
    task_chapter,
    name,
    introduction,
    herocard,
    source_folder,
    study_material {
      id,
      type
    }
  },
  class_task {
    status
  }
`

const standardTaskFields = `
  id,
  type,
  description,
  config,
  scene_number,
  level,
  chapter {
    task_chapter,
    name,
    introduction,
    herocard,
    source_folder,
    study_material {
      id,
      type
    }
  }
`

const codeFields = `
  success
`

export const task = {
  async getAssignment(slug, fields = null) {
    fields = fields === null ? standardFields : fields

    const query = `
      query getAssignment($slug: String!) {
        assignment(slug: $slug) {
          ${fields}
        }
      }
    `

    return doRequest(query, {slug: slug})
  },

  async validateCode(code, fields = null) {
    fields = fields === null ? codeFields : fields

    const query = `
      query validateTaskCode($code: String!) {
        taskCode(code: $code) {
          ${fields}
        }
      }
    `

    return doRequest(query, {code: code})
  },

  async getTask(id, fields = null) {
    fields = fields === null ? standardTaskFields : fields

    const query = `
      query getTask($id: ID!) {
        task(id: $id) {
          ${fields}
        }
      }
    `
    return doRequest(query, {id: id})
  },

  async getAssignments(slug, fields = null) {
    fields = fields === null ? standardFields : fields

    const query = `
      query getAssignments($slug: String!) {
        assignments(slug: $slug) {
          ${fields}
        }
      }
    `

    return doRequest(query, {slug: slug})
  },

  async submitAssignment(slug, submission, completed, fields = null) {
    fields = fields === null ? standardFields : fields
    const query = `
      mutation SubmitAssignment($slug: String!, $submission: Json!, $completed: Boolean!) {
        submitAssignment(slug: $slug, submission: $submission, completed: $completed) {
          ${fields}
        }
      }
    `

    return doRequest(query, {slug: slug, submission: submission, completed: completed})
  },

  async getVimeoVideo(video_url, fields = null) {
    let video_fields = `
      embed {
        html
      }
    `
    fields = fields === null ? video_fields : fields

    const query = `
      query getVimeoVideo($url: String!) {
        vimeoVideo(url: $url) {
          ${fields}
        }
      }
    `
    return doRequest(query, {url: video_url})
  },

  async submitUsername(code, username, fields = null) {
    fields = fields === null ? standardFields : fields
    const query = `
      query SubmitUsername($code: String!, $username: String!) {
        submitUsername(code: $code, username: $username) {
          ${fields}
        }
      }
    `

    return doRequest(query, {code: code, username: username})
  }

}
